
import { Component, Vue, Prop } from "vue-property-decorator";
import Axios from "axios";
import VueNumeric from "vue-numeric";
import { API_STORE } from "@/config";
import { getAPIAuthorizedHeader } from "@/services/common";
import { PaymentTransaction } from "@/models/paymentTransaction";
import { TRANSFER_TYPE } from "@/constant";
import DatePicker from "vuejs-datepicker";

@Component({ components: { VueNumeric, DatePicker } })
export default class PaymentTransactionComponent extends Vue {
  @Prop() public data;
  public paymentTransaction = new PaymentTransaction();
  public transferType = TRANSFER_TYPE;
  public imageFile = null;
  public imageSrc = null;
  public bankList = [];
  public disableSubmitbutton = false;

  public fileChangeEvent(event) {
    this.imageSrc = URL.createObjectURL(event.target.files[0]);
    this.imageFile = event.target.files[0];
  }

  public async validateAndSubmit() {
    let valid = await this.$validator.validateAll();
    if (valid) {
      this.disableSubmitbutton = true;
      this.$showLoader(true);
      let formData = new FormData();
      if (this.imageFile) {
        formData.append("file", this.imageFile);
      }
      this.paymentTransaction["userType"] = this.$userType;
      this.paymentTransaction["performedBy"] = this.$userId;
      this.paymentTransaction["status"] = "Requested";
      this.paymentTransaction["declinedReason"] =
        this.paymentTransaction.remarks;
      formData.append("jsonData", JSON.stringify(this.paymentTransaction));

      let response = await Axios.post(
        API_STORE.PORTAL + "creditOrDebitPaymentTransaction",
        formData,
        {
          headers: getAPIAuthorizedHeader(),
        }
      );
      this.disableSubmitbutton = false;
      this.$showLoader(false);
      if (response) {
          this.$snotify.success(response.data.message);
          this.$emit("updatePaymentTransaction", true);
      }
    }
  }

  resetForm() {
    this.$emit("cancel", true);
  }
  public async getBankList() {
    try {
      let response = await Axios.get(API_STORE.ADMIN + "getBankList", {
        params: {
          active: true,
        },
        headers: getAPIAuthorizedHeader(),
      });
      if (response && response.data) this.bankList = response.data.bankList;
    } catch (error) {}
  }

  mounted() {
    this.getBankList();
    this.paymentTransaction.userId = this.data.userId;
    this.paymentTransaction.subdomain = this.data.subdomain;
    this.paymentTransaction.transactionType = this.data.transactionType;
    this.paymentTransaction.walletType = "wallet";
  }
}
